import React, { useRef, useEffect } from 'react';
import './VideoTile.css';

const VideoTile = ({ stream, name, isMuted, isVideoOff, isLocal, isLarge, isScreenSharing = false }) => {
  const videoRef = useRef(null);
  const tileRef = useRef(null);

  useEffect(() => {
    console.log('VideoTile stream updated:', name, stream?.id, stream?.getTracks()?.length);
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play().catch((err) => {
        console.log('Video autoplay blocked or delayed:', name, err);
      });
    } else if (videoRef.current && !stream) {
      videoRef.current.srcObject = null;
    }
  }, [stream, name]);

  const showVideo = stream && !isVideoOff;

  // Gestion du plein écran
  const toggleFullscreen = () => {
    if (!tileRef.current) return;
    
    if (!document.fullscreenElement) {
      tileRef.current.requestFullscreen().catch(err => {
        console.error('Erreur plein écran:', err);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <div 
      ref={tileRef}
      className={`video-tile ${isLocal ? 'video-tile-local' : ''} ${isLarge ? 'video-tile-large' : ''}`}
    >
      {showVideo ? (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted={isLocal}
        />
      ) : (
        <div className="video-placeholder">
          <div className="avatar">
            {name?.charAt(0)?.toUpperCase() || '?'}
          </div>
        </div>
      )}
      
      <div className="video-info" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', padding: '6px 8px', width: 'fit-content', borderRadius: '8px', margin: '0 8px 8px 8px' }}>
        <span className="video-name">
          {name} {isLocal && '(Toi)'}
        </span>
        <div className="video-status">
          {isMuted && (
            <span className="status-icon muted" title="Muted">
              🔇
            </span>
          )}
          {isVideoOff && (
            <span className="status-icon video-off" title="Video Off">
              📷
            </span>
          )}
        </div>
      </div>

      {/* Bouton plein écran - seulement si partage d'écran */}
      {isScreenSharing && (
        <button 
          className="fullscreen-btn"
          onClick={(e) => {
            e.stopPropagation();
            toggleFullscreen();
          }}
          title="Plein écran"
        >
          ⛶
        </button>
      )}
    </div>
  );
};

export default VideoTile;
